import UIDs from "../../../../UIDs";

const uid = UIDs.screens.homework.homeworkhistory;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SET_PAGEINDEX: `${uid}.setPageIndex`,
    REPLY_UNIT_ASYNC: `${uid}.replyUnitAsync`,
    REPLY_UNIT_SUCCESS: `${uid}.replyUnitSuccess`,
    REPLY_UNIT_FAILURE: `${uid}.replyUnitFailure`,
    UPDATE_SETTINGS: `${uid}.updateSettings`,
    PLAY_COMMENT_AUDIO: `${uid}.playCommentAudio`,
    TOGGLE_TOPIC_VISIBILITY:`${uid}.toggleTopicVisibility`,
};

export { ActionTypes };
